import { useBreakpointValue } from 'native-base';

export const useIsMobileBreakpoint = (): boolean => {
  return useBreakpointValue({
    base: true,
    md: false,
  });
};

export const useIsDesktopBreakpoint = (): boolean => {
  return useBreakpointValue({
    base: false,
    md: true,
  });
};

export const useIsDesktopLargeBreakpoint = (): boolean => {
  return useBreakpointValue({
    base: false,
    lg: true,
  });
};
